import { Text } from '@chakra-ui/react'

import CustomFormSingleFileAnswer from './components/CustomFormSingleFileAnswer'
import CustomFormNPSAnswer from './components/CustomFormNPSAnswer'
import CustomFormEntitiesAnswer from './components/CustomFormEntitiesAnswer'
import CustomFormTextAnswer from './components/CustomFormTextAnswer'
import CustomFormNumberAnswer from './components/CustomFormNumberAnswer'
import CustomFormSingleSelectionBoxAnswer from './components/CustomFormSingleSelectionBoxAnswer'
import CustomFormMultipleSelectionBoxAnswer from './components/CustomFormMultipleSelectionBoxAnswer'
import CustomFormSingleSelectionListAnswer from './components/CustomFormSingleSelectionListAnswer'
import CustomFormCEPAnswer from './components/CustomFormCEPAnswer'
import CustomFormDocumentsAnswer from './components/CustomFormDocumentsAnswer'
import CustomFormMultipleFilesAnswer from './components/CustomFormMultipleFilesAnswer'
import { useCustomFormAnswer } from '../../../../contexts/CustomFormViewerQuestionManager/Provider'

export default function CustomFormAnswerSelection() {
  const { answer } = useCustomFormAnswer()

  if (answer.answer && answer.answer?.length === 0) {
    return <Text variant="noData">Sem resposta</Text>
  }

  switch (answer?.kind) {
    case 'SHORT_TEXT':
      return <CustomFormTextAnswer />
    case 'PHONE':
      return <CustomFormTextAnswer />
    case 'LONG_TEXT':
      return <CustomFormTextAnswer />
    case 'INTEGER':
    case 'DECIMAL':
      return <CustomFormNumberAnswer />
    case 'EMAIL':
      return <CustomFormTextAnswer />
    case 'CEP':
      return <CustomFormCEPAnswer />
    case 'DOCUMENT':
      return <CustomFormDocumentsAnswer />
    case 'SINGLE_SELECTION_BOX':
      return <CustomFormSingleSelectionBoxAnswer />
    case 'MULTIPLE_SELECTION_BOX':
      return <CustomFormMultipleSelectionBoxAnswer />
    case 'SINGLE_SELECTION_LIST':
      return <CustomFormSingleSelectionListAnswer />
    case 'SINGLE_FILE_UPLOAD':
      return <CustomFormSingleFileAnswer />
    case 'MULTIPLE_FILE_UPLOAD':
      return <CustomFormMultipleFilesAnswer />
    case 'ENTITY':
      return <CustomFormEntitiesAnswer />
    case 'DATE':
      return <CustomFormTextAnswer />
    case 'TIME':
      return <CustomFormTextAnswer />
    case 'NPS':
      return <CustomFormNPSAnswer />
    default:
      return null
  }
}
